import { serverUrl } from "../config";

const openApi = async (cellNumber, clientId) => {
  try {
    const res = await fetch(`${serverUrl}/open`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        data: {
          cellToOpen: cellNumber,
          clientId: clientId,
        },
      }),
    });

    if (res.ok) {
      const jsonData = await res.json();
      return {
        clientId: jsonData["clientId"],
        cellResult: jsonData["data"]["cellResult"],
        result: jsonData["data"]["result"],
        currentMultiplier: jsonData["data"]["currentMultiplier"],
        nextMultiplier: jsonData["data"]["nextMultiplier"],
        currentBalance: jsonData["data"]["currentBalance"],
        winningAmount: jsonData["data"]["winningAmount"],
        openedIndexes: jsonData["data"]["openedIndexes"],
        minesIndexes: jsonData["data"]["minesIndexes"],
      };
    }
  } catch (e) {
    console.error(e);
  }
};
export default openApi;
